(() => {
class HomeHeroCarousel {
  constructor(section) {
    this.section = section;
    this.slides = [...section.querySelectorAll('[data-hero-slide]')];
    this.contents = [...section.querySelectorAll('[data-hero-content]')];
    this.dots = [...section.querySelectorAll('[data-hero-dot]')];
    this.previousButton = section.querySelector('[data-hero-previous]');
    this.nextButton = section.querySelector('[data-hero-next]');
    this.status = section.querySelector('[data-hero-status]');
    this.currentIndex = 0;
    this.interval = null;
    this.delay = Number(section.dataset.autoplayDelay) || 6500;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.touchStartX = null;
    this.touchStartY = null;

    if (this.slides.length < 2) return;

    this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1, true));
    this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1, true));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));

    section.addEventListener('touchstart', (event) => this.handleTouchStart(event), { passive: true });
    section.addEventListener('touchend', (event) => this.handleTouchEnd(event), { passive: true });
    section.addEventListener('touchcancel', () => this.resetTouch(), { passive: true });

    section.addEventListener('mouseenter', () => this.stop());
    section.addEventListener('mouseleave', () => this.start());
    section.addEventListener('focusin', () => this.stop());
    section.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!section.contains(document.activeElement)) this.start();
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop();
      else this.start();
    });

    this.start();
  }

  handleTouchStart(event) {
    if (event.touches.length !== 1) {
      this.resetTouch();
      return;
    }

    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
    this.stop();
  }

  handleTouchEnd(event) {
    if (this.touchStartX === null || this.touchStartY === null || event.changedTouches.length !== 1) {
      this.resetTouch();
      this.start();
      return;
    }

    const horizontalDistance = event.changedTouches[0].clientX - this.touchStartX;
    const verticalDistance = event.changedTouches[0].clientY - this.touchStartY;
    const isHorizontalSwipe = Math.abs(horizontalDistance) >= 50 && Math.abs(horizontalDistance) > Math.abs(verticalDistance) * 1.25;

    this.resetTouch();

    if (isHorizontalSwipe) {
      this.show(this.currentIndex + (horizontalDistance < 0 ? 1 : -1), true);
    } else {
      this.start();
    }
  }

  resetTouch() {
    this.touchStartX = null;
    this.touchStartY = null;
  }

  show(index, announce = false) {
    this.currentIndex = (index + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === this.currentIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });

    this.contents.forEach((content, contentIndex) => {
      const active = contentIndex === this.currentIndex;
      content.classList.toggle('is-active', active);
      content.setAttribute('aria-hidden', String(!active));
    });

    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === this.currentIndex;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });

    if (announce && this.status) {
      this.status.textContent = `Afbeelding ${this.currentIndex + 1} van ${this.slides.length}`;
    }

    this.stop();
    this.start();
  }

  start() {
    if (this.slides.length < 2 || this.reducedMotion.matches || this.interval) return;
    this.interval = window.setInterval(() => this.show(this.currentIndex + 1), this.delay);
  }

  stop() {
    if (!this.interval) return;
    window.clearInterval(this.interval);
    this.interval = null;
  }
}

function initializeHomeHeroCarousels(scope = document) {
  scope.querySelectorAll('[data-home-hero-carousel]').forEach((section) => {
    if (section.homeHeroCarousel) return;
    section.homeHeroCarousel = new HomeHeroCarousel(section);
  });
}

initializeHomeHeroCarousels();

document.addEventListener('shopify:section:load', (event) => initializeHomeHeroCarousels(event.target));

document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target.closest('[data-hero-slide]');
  const carousel = slide?.closest('[data-home-hero-carousel]')?.homeHeroCarousel;
  if (!slide || !carousel) return;
  carousel.show(carousel.slides.indexOf(slide));
  carousel.stop();
});
})();
